/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(function ($) {
	jQuery('.faq__item').each(function (e) {

		let faq_item = this;
		jQuery(this, ".faq__btn").toggle(function (e) {

			jQuery(faq_item).removeClass('--closed').addClass('--open');

		}, function (e) {

			jQuery(faq_item).removeClass('--open').addClass('--closed');

		})
	});

});


function faqColumnSplit() {
	jQuery('.faq__items').innerHeight(Math.ceil(jQuery('.faq__item').length / 2) * jQuery('.faq__item').innerHeight() + 10);
}
